var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommitment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON COMMITMENTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.50927 10.3894C3.50927 10.3894 1.75049 10.3394 1.75049 12.2396C1.75049 14.1398 1.94739 19.3513 1.94739 19.3513C1.94739 19.3513 2.10091 26.8755 11.1285 27.3381C19.6754 27.7774 20.4564 19.7905 20.4564 19.7905L20.2594 12.6789C20.2594 12.6789 20.4063 10.3428 18.4539 10.3894C16.5016 10.4359 3.50927 10.3894 3.50927 10.3894Z",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5732 13.3145C12.3323 13.3145 13.8838 14.0692 14.0221 15.6384C14.1704 17.3457 12.9944 18.1648 12.9944 18.1648L14.8275 22.8771H8.15208C7.27256 22.8771 9.32313 18.3029 9.32313 18.3029C9.32313 18.3029 7.7815 17.4837 7.85562 15.5003C7.92973 13.5169 10.5683 13.3145 10.5683 13.3145H10.5732Z",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.73058 10.0968C4.73058 10.0968 3.4991 2.07664 11.5188 2.01341C17.8197 1.96349 16.695 10.2931 16.695 10.2931",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitment);
export default __webpack_public_path__ + "static/media/commitment.e616ea1770b3e043264e41cd38fbce4b.svg";
export { ForwardRef as ReactComponent };